import React from "react";
import { Component } from "react";
import axios from "axios";
import { Input, Button } from "mdbreact";
import domain from ".././../../../domain";

import { Row, Col, Card, CardBody, CardTitle } from "mdbreact";

import moment from "moment";
moment.suppressDeprecationWarnings = true;

//var moment = require('moment-timezone');
let enumerateDaysBetweenDates = function (startDate, endDate) {
  var dates = [];

  var currDate = moment(startDate).startOf("day");
  var lastDate = moment(endDate).startOf("day");

  dates.push(currDate.toDate());
  while (currDate.add(1, "days").diff(lastDate) <= 0) {
    dates.push(currDate.clone().toDate());
  }

  return dates;
};
// let flag=false;

export default class AddScheduleById extends Component {
  constructor(props) {
    super(props);
    this.state = {
      course_name: "",
      course_id: "",
      session_date: "",
      topic: "",
      course_data: null,
      session_data: null,
      start_time: "09:00:00",
      end_time: "09:00:00",
      status: false,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange = (e) => {
    e.preventDefault();
    this.setState({
      [e.target.name]: e.target.value,
    });
    console.log(e.target.name + "" + e.target.value);
  };

  fetchCourseAndSessions() {
    let courseId = this.props.match.params.id;
    console.log(courseId);
    axios
      .all([
        axios.get(`${domain.DBServer}/fetch-course/${courseId}`),
        axios.get(`${domain.DBServer}/fetch-sessions/${courseId}`),
      ])
      .then(
        axios.spread((course, session) => {
          console.log(course.data);
          console.log(session.data);
          if (course.data) {
            this.setState({
              course_data: course.data,
              course_id: course.data[0].course_id,
              course_name: course.data[0].title,
              session_date: moment(course.data[0].start_date)
                .tz("Asia/Calcutta")
                .format("MM-DD-YYYY"),
              //session_data: session.data,
              //session_date:session.data[0].session_date,
            });
          }
          if (session.data) {
            this.setState({
              session_data: session.data,
            });
          }
        })
      )
      .catch((error) => console.log(error));
  }

  componentDidMount() {
    this.fetchCourseAndSessions();
  }

  async checkTimes(id) {
    let r = false;

    const result = await axios.get(
      `${domain.DBServer}/fetch-sessions-by-date/${id}`
    );
    console.log(result.data);
    if (result.data != null) {
      r = result.data.some((data) => {
        let format = "hh:mm:ss";
        let beginningTime = moment(data.start_time, format);
        let endingTime = moment(data.end_time, format);
        let submitted_start_time = moment(this.state.start_time, format);
        console.log(submitted_start_time);
        console.log(this.state.start_time);
        let submitted_end_time = moment(this.state.end_time, format);
        //  if(submitted_end_time.isSame(submitted_start_time))
        //       return false;
        if (
          submitted_start_time.isBetween(
            beginningTime,
            endingTime,
            null,
            "[)"
          ) ||
          submitted_end_time.isBetween(beginningTime, endingTime, "(]")
        ) {
          return true;
        }
        return true;
      });
    }
    return r;
  }

  insertSchedule = (course) => {
    axios({
      method: "post",
      url: `${domain.DBServer}/add_session_wise_details`,
      data: course,
    })
      .then((response) => {
        const { success, msg } = response.data;

        if (success) {
          alert(msg);
          //console.log(this)
          this.props.history.replace(`/view-schedules/${this.state.course_id}`);
        } else {
          console.log("else");
          alert(msg);
        }
      })
      .catch((response) => {
        console.log(response);
      });
  };

  async onSubmit(e) {
    e.preventDefault();

    const newSchedule = {
      course_id: this.state.course_id,
      session_date: this.state.session_date,
      start_time: this.state.start_time,
      end_time: this.state.end_time,
      topic: this.state.topic,
      lname: this.state.lname,
    };
    let submitted_start_time = this.state.start_time;
    let submitted_end_time = this.state.end_time;
    if (submitted_end_time === submitted_start_time) {
      alert("You have selected same time");
      return false;
    }

    let start_time = moment(submitted_start_time, "hh:mm:ss a");
    let end_time = moment(submitted_end_time, "hh:mm:ss a");
    let diff = end_time.diff(start_time, "hours");
    if (diff < 0) {
      alert(
        "You have selected wrong timings( End time is less than Start Time)"
      );
      return false;
    }
    console.log(this.state.session_date);
    // let s=await  this.checkTimes(this.state.session_date);

    // console.log(s)

    // let r=window.confirm('Check once again the details before submitting')
    this.insertSchedule(newSchedule);
    // if(r)
    // {

    //  if(s===true)
    //  {
    //     alert('The session you have entered  overlaps with already existing sessions')
    //     return false;

    //  }

    // }
    // else
    // {
    //     alert('You are entered same timeslots')
    //     return false;
    // }
  }
  intialValues = (e) => {
    alert(e.target.name);
    this.setState({
      date: "",
      start_time: "",
      end_time: "",
      lname: "",
      topic: "",
    });
  };

  render() {
    let options, result;

    if (this.state.course_data) {
      let startd = moment(this.state.course_data[0].start_date)
        .tz("Asia/Calcutta")
        .format("MM-DD-YYYY");
      let endd = moment(this.state.course_data[0].end_date)
        .tz("Asia/Calcutta")
        .format("MM-DD-YYYY");
      result = enumerateDaysBetweenDates(startd, endd);
      if (result) {
        options = result.map((dates, key) => {
          return (
            <option
              key={key}
              value={moment(dates).tz("Asia/Calcutta").format("MM-DD-YYYY")}
            >
              {moment(dates).tz("Asia/Calcutta").format("DD-MMM-YYYY")}
            </option>
          );
        });
      }
    }

    return (
      <div>
        <Row className="justify-content-md-center">
          <Col md="6">
            <Card>
              <CardBody>
                {/* <Link className="btn grey" to="/Home">Back</Link> */}
                <br />
                <br />
                <CardTitle>Add Schedule for {this.state.course_name}</CardTitle>

                <hr />

                {/* <Link className="btn grey" to={`/add-timings/${this.props.match.params.id}`}>Fix the Timings</Link> */}
                <form onSubmit={this.onSubmit.bind(this)}>
                  <div className="form-group">
                    <label>Course Name</label>

                    <Input
                      className="form-control"
                      id="course"
                      name="course_name"
                      value={this.state.course_name}
                      autoFocus
                      required
                      disabled
                    ></Input>
                  </div>
                  <div className="form-group">
                    <label>Date</label>
                    <select
                      className="form-control"
                      id="date"
                      name="session_date"
                      onChange={this.handleInputChange}
                      pattern="[0-9]{0,1}/[0-9]{0,1}/[0-9]{4}"
                      required
                      value={moment(this.state.session_date)
                        .tz("Asia/Calcutta")
                        .format("MM-DD-YYYY")}
                      selected={moment(this.state.session_date)
                        .tz("Asia/Calcutta")
                        .format("MM-DD-YYYY")}
                    >
                      {options}
                    </select>
                  </div>
                  <div className="form-group">
                    {/* <p align="right" style={{color:"red"}}>* All Session Times are 12 hour format </p><br/> */}
                    <label>Start Time</label>

                    <Input
                      id="start_time"
                      type="time"
                      name="start_time"
                      min="09:00AM"
                      max="05:00PM"
                      value={this.state.start_time}
                      required
                      onChange={this.handleInputChange}
                    />
                    <span className="validity"></span>
                  </div>
                  <div className="form-group">
                    <label>End Time</label>
                    <Input
                      id="end_time"
                      type="time"
                      name="end_time"
                      min="09:00AM"
                      max="05:00PM"
                      value={this.state.end_time}
                      required
                      onChange={this.handleInputChange}
                    />
                    <span className="validity"></span>
                  </div>
                  {/* <div className="form-group">
      <label>End Time</label>
      <input type="time" name="end_time" onChange={this.handleInputChange} value={this.state.end_time}/>
    </div>
    */}
                  {/* <Input type="date" value={this.state.date} label="Date" name="date" onChange={this.handleInputChange} pattern="[0-9]{0,1}/[0-9]{0,1}/[0-9]{4}" validate required /> */}
                  <Input
                    type="text"
                    value={this.state.topic || ""}
                    label="Topic"
                    name="topic"
                    id="topic"
                    onChange={this.handleInputChange}
                    validate
                    required
                  />
                  <Input
                    type="text"
                    value={this.state.lname || ""}
                    label="Lecturer Name"
                    name="lname"
                    id="lname"
                    onChange={this.handleInputChange}
                    validate
                    required
                  />
                  <Button type="submit">Submit</Button> &nbsp;&nbsp;
                  {/* <Button type="reset" name="clear" onClick={this.intialValues} >Clear Values</Button> */}
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}
